module.exports = __webpack_public_path__ + "static/media/networking.583b6386.jpg";